export default {
	data() {
    return {
      email: 'moogdb@gmail.com'
    }
  },
}